/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Epicdevportal2Inputs */

const id_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portal Pengembang Epic Games`)
};

const ms_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portal Pembangun Epic Games`)
};

const da_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Developer portalen`)
};

const de_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Developer-Portals`)
};

const en_us2_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Developer portal`)
};

const es_es2_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portal de desarrolladores de Epic Games`)
};

const es_mx2_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portal de desarrolladores de Epic Games`)
};

const fil_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portal ng Epic Games Developer`)
};

const fr_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portail développeur Epic Games`)
};

const it_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portale per sviluppatori di Epic Games`)
};

const hu_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Fejlesztői portálon belül`)
};

const nl_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Developer-portal`)
};

const no_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Developer-portalen`)
};

const pl_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portalu deweloperskim Epic Games`)
};

const pt_br2_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal do desenvolvedor da Epic Games`)
};

const pt_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portal de desenvolvedores da Epic Games`)
};

const ro_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portalul de dezvoltatori Epic Games`)
};

const fi_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Gamesin kehittäjäportaalissa`)
};

const sv_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games utvecklarportal`)
};

const vi_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cổng thông tin nhà phát triển Epic Games`)
};

const tr_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Geliştirici portalı`)
};

const cs_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portálu pro vývojáře Epic Games`)
};

const bg_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`портала за разработчици на Epic Games`)
};

const ru_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`портале разработчика Epic Games`)
};

const uk_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`порталі розробників Epic Games`)
};

const ar_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوابة مطوري Epic Games`)
};

const hi_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games डेवलपर पोर्टल`)
};

const th_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พอร์ทัลนักพัฒนา Epic Games`)
};

const ja_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games デベロッパーポータル`)
};

const zh_cn2_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏开发者门户`)
};

const zh_hant1_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲開發者入口`)
};

const ko_privacy_epicdevportal2 = /** @type {(inputs: Privacy_Epicdevportal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games 개발자 포털`)
};

/**
* | output |
* | --- |
* | "Epic Games Developer portal" |
*
* @param {Privacy_Epicdevportal2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_epicdevportal2 = /** @type {((inputs?: Privacy_Epicdevportal2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Epicdevportal2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_epicdevportal2(inputs)
	if (locale === "ms") return ms_privacy_epicdevportal2(inputs)
	if (locale === "da") return da_privacy_epicdevportal2(inputs)
	if (locale === "de") return de_privacy_epicdevportal2(inputs)
	if (locale === "en-US") return en_us2_privacy_epicdevportal2(inputs)
	if (locale === "es-ES") return es_es2_privacy_epicdevportal2(inputs)
	if (locale === "es-MX") return es_mx2_privacy_epicdevportal2(inputs)
	if (locale === "fil") return fil_privacy_epicdevportal2(inputs)
	if (locale === "fr") return fr_privacy_epicdevportal2(inputs)
	if (locale === "it") return it_privacy_epicdevportal2(inputs)
	if (locale === "hu") return hu_privacy_epicdevportal2(inputs)
	if (locale === "nl") return nl_privacy_epicdevportal2(inputs)
	if (locale === "no") return no_privacy_epicdevportal2(inputs)
	if (locale === "pl") return pl_privacy_epicdevportal2(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_epicdevportal2(inputs)
	if (locale === "pt") return pt_privacy_epicdevportal2(inputs)
	if (locale === "ro") return ro_privacy_epicdevportal2(inputs)
	if (locale === "fi") return fi_privacy_epicdevportal2(inputs)
	if (locale === "sv") return sv_privacy_epicdevportal2(inputs)
	if (locale === "vi") return vi_privacy_epicdevportal2(inputs)
	if (locale === "tr") return tr_privacy_epicdevportal2(inputs)
	if (locale === "cs") return cs_privacy_epicdevportal2(inputs)
	if (locale === "bg") return bg_privacy_epicdevportal2(inputs)
	if (locale === "ru") return ru_privacy_epicdevportal2(inputs)
	if (locale === "uk") return uk_privacy_epicdevportal2(inputs)
	if (locale === "ar") return ar_privacy_epicdevportal2(inputs)
	if (locale === "hi") return hi_privacy_epicdevportal2(inputs)
	if (locale === "th") return th_privacy_epicdevportal2(inputs)
	if (locale === "ja") return ja_privacy_epicdevportal2(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_epicdevportal2(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_epicdevportal2(inputs)
	return ko_privacy_epicdevportal2(inputs)
});
export { privacy_epicdevportal2 as "privacy.epicDevPortal" }